import request from "@/utils/request";

export function pollenProcessing2Get(params) {
    return request({
        url: "/api/services/app/PollenProcessing2/Get",
        method: "GET",
        params
    });
}

export function pollenProcessing2CreateWithImages(data) {
    return request({
        url: "/api/services/app/PollenProcessing2/CreateWithImages",
        method: "post",
        data
    });
}

export function pollenProcessing2Update(data) {
    return request({
        url: "/api/services/app/PollenProcessing2/Update",
        method: "put",
        data
    });
}

export function pollenProcessing2Delete(params) {
    return request({
        url: "/api/services/app/PollenProcessing2/Delete",
        method: "delete",
        params
    });
}

export function pollenProcessing2DeleteMany(data) {
    return request({
        url: "/api/services/app/PollenProcessing2/DeleteMany",
        method: "post",
        data
    });
}




// WEBPACK FOOTER //
// ./src/api/pollen_processing_2.js